import { Select } from 'antd';
import range from 'lodash.range';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { DictionarySettingsValueModel } from 'stores/models/fieldsSettings';

import { useDictionaryTableContext } from '../../context';

type Props = {
  index: number;
  entity: DictionarySettingsValueModel;
};

/**
 * Селектор выбора порядка, должен обновляться когда порядок меняется
 * @param index
 * @param entity
 * @constructor
 */
const OrderSelect: React.FC<Props> = ({ index, entity }) => {
  const { store } = useDictionaryTableContext();

  // Для перерендера при изменении порядка
  const key = `${entity.id}-${index}`;

  const handleOnChange = React.useCallback(
    (value) => {
      store.onSortEnd({
        oldIndex: index,
        newIndex: value - 1,
      });
    },
    [index, store]
  );

  return (
    <Select<number>
      key={key}
      defaultValue={index + 1}
      onChange={handleOnChange}
    >
      {range(1, store.values.length + 1).map((el) => (
        <Select.Option value={el} key={el}>
          {el}
        </Select.Option>
      ))}
    </Select>
  );
};

export default observer(OrderSelect);
